<template>
  <svg
    class="svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
  >
    <path
      d="M511.027,245.413c-2.028-4.927-6.888-8.126-12.198-7.997l-21.577,0.424c-4.344-57.769-29.317-111.502-71.13-152.473 c-44.974-44.069-104.336-68.338-167.151-68.338C107.203,17.029,0,124.23,0,256s107.203,238.972,238.972,238.972 c66.174,0,129.979-27.807,175.054-76.294c7.048-7.581,10.721-17.453,10.344-27.797c-0.377-10.344-4.76-19.922-12.34-26.969 c-7.581-7.049-17.444-10.73-27.798-10.347c-10.344,0.377-19.922,4.761-26.97,12.343c-30.463,32.766-73.577,51.558-118.29,51.558 c-89.033,0-161.467-72.434-161.467-161.467S149.939,94.532,238.972,94.532c80.318,0,147.669,58.973,159.587,136.838l-25.133-2.68 c-5.195-0.555-10.216,2.077-12.715,6.667c-2.5,4.59-1.987,10.233,1.298,14.297l59.292,73.351c2.268,2.807,5.607,4.537,9.209,4.769 c3.609,0.245,7.136-1.05,9.749-3.538l67.735-64.555C511.852,256.007,513.055,250.34,511.027,245.413z M432.583,295.865 l-30.858-38.176l9.962,1.062c3.773,0.411,7.531-0.873,10.278-3.489c2.746-2.616,4.206-6.308,3.988-10.094 c-5.675-98.955-87.807-176.47-186.98-176.47C135.693,68.698,51.67,152.722,51.67,256s84.024,187.302,187.302,187.302 c51.866,0,101.877-21.797,137.211-59.804c2.35-2.528,5.543-3.989,8.989-4.114c3.462-0.145,6.739,1.099,9.266,3.449 c2.527,2.348,3.988,5.542,4.113,8.989c0.125,3.448-1.099,6.739-3.448,9.266c-40.204,43.246-97.113,68.049-156.132,68.049 c-117.524,0-213.137-95.613-213.137-213.137S121.447,42.863,238.97,42.863c114.983,0,210.569,93.497,213.076,208.419 c0.154,7.035,5.903,12.636,12.91,12.636c0.085,0,1.166-0.021,1.166-0.021L432.583,295.865z"
      fill="#9d9fa2"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'Replay',
};
</script>

<style scoped lang="scss">
.svg {
  flex-grow: 1;
}
</style>
